<ion-header>
  <ion-toolbar>
    <ion-title>{{ titleKey | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">{{ "General.lukk" | translate }}</ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar>
    <ion-searchbar
      #searchbar
      [(ngModel)]="searchTerm"
      (ionInput)="filter()"
      [debounce]="0"
      placeholder="{{ 'General.Type2Search' | translate }}"
    ></ion-searchbar>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list lines="full">
    <ion-item
      *ngIf="selectableVisible.length > 1"
      button
      detail="false"
      class="select-all"
      (click)="toggleAllVisible()"
    >
      <ion-checkbox
        slot="start"
        [checked]="allVisibleSelected"
        aria-hidden="true"
      ></ion-checkbox>
      <ion-label>{{ "Picker.selectAllVisible" | translate }}</ion-label>
    </ion-item>

    <ion-item
      *ngFor="let item of filteredItems"
      button
      detail="false"
      [disabled]="item.disabled"
      [class.is-selected]="selected.has(item.id)"
      (click)="toggle(item)"
    >
      <ion-checkbox
        slot="start"
        [checked]="item.disabled || selected.has(item.id)"
        aria-hidden="true"
      ></ion-checkbox>
      <ion-label>
        <h3>{{ item.label }}</h3>
        <p *ngIf="item.sublabel">{{ item.sublabel }}</p>
      </ion-label>
      <ion-note slot="end" *ngIf="item.disabled">{{
        "Picker.alreadyAdded" | translate
      }}</ion-note>
    </ion-item>
  </ion-list>

  <div *ngIf="filteredItems.length === 0" class="picker-empty">
    {{ (items.length === 0 ? emptyKey : "Picker.noMatches") | translate }}
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-button
      expand="block"
      class="picker-confirm"
      [disabled]="selected.size === 0"
      (click)="confirm()"
    >
      <ion-icon name="add-outline" slot="start"></ion-icon>
      {{ "Picker.addSelected" | translate: { count: selected.size } }}
    </ion-button>
  </ion-toolbar>
</ion-footer>
